import React from 'react'
import './FooterBar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faEnvelope, faPhone, faGlobe } from '@fortawesome/free-solid-svg-icons'
import data from '../../data/index.json';

const FooterBar = () => {
  return (
    <div className='footerbar'>
      <div className='footerbar-up-side'>
        <div className='footer-content-title-main'>
          <div className='footer-content-title'>
            <img src={data.siteContent.footer.images.government} alt="nation" height="60px"/>
            <p className='company-name'>{data.siteContent.footer.companyName}</p>
            <img src={data.siteContent.footer.images.company} alt="logo" height="50px" />
          </div>
          <div className='govement-infor'>
            <img src={data.siteContent.footer.images.government_info} alt="info" height="60px" />
          </div>
        </div>
        <div className='footer-content-link'>
          <h3>{data.siteContent.footer.quickLinks.title}</h3>

          <div className='footer-quick-links'>
            {data.siteContent.footer.quickLinks.links.map((link, index) => (
              <a key={index} href={link.path}>{link.name}</a>
            ))}
          </div>
        </div>
        <div className='footer-contact'>
          <h3>{data.siteContent.footer.contact.title}</h3>
          <a href="/contact-us"
          className='footer-contact-us' style={{ maxWidth: "260px" }}>
            <FontAwesomeIcon icon={faLocationDot} color='white' size='26px' className='footer-contact-us-icon' />{data.siteContent.footer.contact.address}
          </a>
          <a href={`mailto:${data.siteContent.footer.contact.email}`}
          className='footer-contact-us'>
            <FontAwesomeIcon icon={faEnvelope} size='26px' className='footer-contact-us-icon' />{data.siteContent.footer.contact.email}
          </a>
          <a href={data.siteContent.footer.contact.website} className='footer-contact-us'>
            <FontAwesomeIcon icon={faGlobe} size='26px' className='footer-contact-us-icon' />{data.siteContent.footer.contact.website}
          </a>
          <a href={`tel:${data.siteContent.footer.contact.phone.replace(/\s/g, '').split('/')[0]}`}
           className='footer-contact-us'>
            <FontAwesomeIcon icon={faPhone} size='26px' className='footer-contact-us-icon' />{data.siteContent.footer.contact.phone}
          </a>
        </div>

      </div>
      <div className='footer-down-bar'>
        <p className='rights-text'>{data.siteContent.footer.copyright.split('DeepBees')[0]}<a 
        href={data.siteContent.footer.developerUrl}
        style = {{color: 'white'}}
        >DeepBees (PVT) LTD</a></p>
      </div>
    </div>
  )
}

export default FooterBar
